import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

interface PublicConfig {
  posthog?: {
    enabled: boolean
    key?: string
    host?: string
  }
  stripe?: {
    enabled: boolean
    publishableKey?: string
    priceLookupKey?: string
  }
  baseUrl?: string
}

const PublicConfigContext = createContext<PublicConfig | null>(null)

export function PublicConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<PublicConfig | null>(null)

  useEffect(() => {
    fetch('/api/public-config')
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error('Failed to fetch public config:', err))
  }, [])

  return (
    <PublicConfigContext.Provider value={config}>
      {children}
    </PublicConfigContext.Provider>
  )
}

/**
 * Hook to access public configuration (PostHog, Stripe, etc.)
 * Values are fetched from server at runtime, never bundled
 */
export function usePublicConfig() {
  const context = useContext(PublicConfigContext)
  if (context === undefined) {
    throw new Error('usePublicConfig must be used within PublicConfigProvider')
  }
  return context
}
